import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import "./MultiPageFormProgressBar.scss"

export interface PageInfoItem {
    pageNumber: number,
    pageTitle: string,
}

interface PageTitleItemProps{
    pageTitle: string
}

interface PageNumberItemProps {
    pageNumber: number;
}

interface MultiPageFormProgressBarProps {
    pageListWithInfo: PageInfoItem[];
    completedTill: Number;
    updateCurrentPage: any;
}

const MultiPageFormProgressBar = ({pageListWithInfo, completedTill, updateCurrentPage}: MultiPageFormProgressBarProps) => {
    
    const PageNumberItem = ({pageNumber}: PageNumberItemProps) => {
        const handleCurrentPageUpdation = () => {
            if (pageNumber <= completedTill) {
                updateCurrentPage(pageNumber);
            }
        }
        return (
            <Box 
                className = {pageNumber <= completedTill ? "item-block completed" : "item-block" } 
                onClick={handleCurrentPageUpdation}>
                <Typography fontFamily={"Arial"}>  
                     {pageNumber} 
                </Typography>              
            </Box>
        )
    }
    
    
    
    const PageTitleItem = ({pageTitle}: PageTitleItemProps) => {
        return (
            <>
                <Box className = "page-title-block">
                    <Typography fontWeight={600}>
                        {pageTitle}

                    </Typography>
                </Box>
            </>
        )
    }

    const SeparatorLine = ({pageNumber}: any) => {
        return (
            <Box 
                width={window.innerWidth / (pageListWithInfo.length + 1) - 35} 
                className={pageNumber < completedTill ? "completed-line line-separator": "line-separator"}>
            </Box>
        )
    }

  return (
    <Box className="multi-page-form-progress-bar">
        <Box className="bar">
        {pageListWithInfo.map((pageInfoItem: PageInfoItem, index:number) => (
                  <Box key = {index} className="center">
                    <PageNumberItem pageNumber = {pageInfoItem.pageNumber}/>
                    {index === pageListWithInfo.length -1 ? <Box></Box> : <SeparatorLine pageNumber = {pageInfoItem.pageNumber}/>}
                  </Box>
        ))}
        </Box>
        
        <Box className="bar">
        {pageListWithInfo.map((pageInfoItem: PageInfoItem, index:number) => (
                  <div>
                        { <Box width={window.innerWidth / (pageListWithInfo.length + 1)}></Box>}

                      <PageTitleItem key = {index}  pageTitle = {pageInfoItem.pageTitle}/>
                        {index === pageListWithInfo.length -1 ? <Box></Box> : <Box width={window.innerWidth / (pageListWithInfo.length + 1)}></Box>}
                      
                  </div>
        ))}
        </Box>
    </Box>
  )
}


export default MultiPageFormProgressBar